
// import React, { useEffect, useState } from "react";
// import Rightcontainer from "../Components/Rightcontainer";
// import "../css/homepage.css";
// import socket from "../Components/socket";
// import { BsWhatsapp, BsTelegram, BsClockHistory } from "react-icons/bs";
// import { FaHeadset, FaShieldAlt } from "react-icons/fa";
// import { RiMessage2Line, RiCustomerService2Line } from "react-icons/ri";

// // --- Premium Theme Colors ---
// const COLORS = {
//     bodyBg: "#F0F2F5",
//     primaryGrad: "linear-gradient(135deg, #1C2533 0%, #2D3748 100%)",
//     accentGrad: "linear-gradient(135deg, #B5894D 0%, #D4AF37 100%)",
//     whatsappGrad: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
//     telegramGrad: "linear-gradient(135deg, #0088CC 0%, #005580 100%)",
//     pureWhite: "#FFFFFF",
//     textDark: "#1A202C",
//     textMuted: "#718096",
//     border: "rgba(181, 137, 77, 0.3)", // Gold tint border
// };

// const Support = () => {
//     const [settingData, setSettingData] = useState();
//     const telegramLink = "https://t.me/";

//     useEffect(() => {
//         const storedSetting = JSON.parse(localStorage.getItem("sitSetting"));
//         if (storedSetting) {
//             setSettingData(storedSetting);
//         }
//         socket.emit('websetting', '');
//     }, []);

//     useEffect(() => {
//         socket.on("websettingGet", (data) => {
//             localStorage.setItem("sitSetting", JSON.stringify(data));
//             setSettingData(data);
//         });
//         return () => socket.off("websettingGet");
//     }, []);

//     const whatsappLink = settingData?.whatsappSupport;

//     return (
//         <>
//             <div className="leftContainer support-page-wrapper">
//                 <div className="container py-4">
//                     <div className="row justify-content-center">
//                         <div className="col-lg-10">
                            
//                             {/* --- PREMIUM HERO BANNER --- */}
//                             <div className="support-hero-card">
//                                 <div className="hero-overlay"></div>
//                                 <div className="hero-content">
//                                     <div className="icon-badge">
//                                         <RiCustomerService2Line size={30} />
//                                     </div>
//                                     <h2 className="fw-800">Help & Support</h2>
//                                     <p>We are available 24/7 to assist you with any queries or technical issues.</p>
//                                     <div className="status-pill">
//                                         <span className="pulse-dot"></span>
//                                         System Status: Operational
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* --- QUICK STATS --- */}
//                             <div className="row g-3 mb-4">
//                                 <div className="col-4">
//                                     <div className="mini-info-card">
//                                         <BsClockHistory className="mb-2" />
//                                         <span>&lt; 5 Min Response</span>
//                                     </div>
//                                 </div>
//                                 <div className="col-4">
//                                     <div className="mini-info-card">
//                                         <FaShieldAlt className="mb-2" />
//                                         <span>100% Secure</span>
//                                     </div>
//                                 </div>
//                                 <div className="col-4">
//                                     <div className="mini-info-card">
//                                         <RiMessage2Line className="mb-2" />
//                                         <span>Live Chat</span>
//                                     </div>
//                                 </div>
//                             </div>

//                             <h5 className="section-title">Select Support Channel</h5>

//                             {/* --- SUPPORT CHANNELS GRID --- */}
//                             <div className="row g-3">
//                                 {/* WhatsApp Channel */}
//                                 {whatsappLink && (
//                                     <div className="col-md-6 col-12">
//                                         <a
//                                             href={`https://wa.me/${whatsappLink}`}
//                                             target="_blank"
//                                             rel="noreferrer"
//                                             className="channel-card wa-border"
//                                         >
//                                             <div className="channel-icon wa-bg">
//                                                 <BsWhatsapp size={32} />
//                                             </div>
//                                             <div className="channel-text">
//                                                 <h4>WhatsApp Support</h4>
//                                                 <p>Chat with our experts instantly</p>
//                                             </div>
//                                             <div className="arrow-btn">→</div>
//                                         </a>
//                                     </div>
//                                 )}

//                                 {/* Telegram Channel */}
//                                 <div className="col-md-6 col-12">
//                                     <a
//                                         href={telegramLink}
//                                         target="_blank"
//                                         rel="noreferrer"
//                                         className="channel-card tg-border"
//                                     >
//                                         <div className="channel-icon tg-bg">
//                                             <BsTelegram size={32} />
//                                         </div>
//                                         <div className="channel-text">
//                                             <h4>Telegram Channel</h4>
//                                             <p>Join for latest news & updates</p>
//                                         </div>
//                                         <div className="arrow-btn">→</div>
//                                     </a>
//                                 </div>
//                             </div>

//                             {/* --- HELPLINE FOOTER --- */}
//                             <div className="helpline-banner mt-4">
//                                 <div className="helpline-left">
//                                     <div className="headset-icon">
//                                         <FaHeadset size={24} />
//                                     </div>
//                                     <div>
//                                         <h6>Official Helpline</h6>
//                                         <p>Trusted support for KAKAKING players</p>
//                                     </div>
//                                 </div>
//                                 <div className="active-badge">
//                                     ONLINE NOW
//                                 </div>
//                             </div>

//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="rightContainer sticky-top">
//                 <Rightcontainer />
//             </div>

//             <style>{`
//                 @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');

//                 .support-page-wrapper {
//                     background: ${COLORS.bodyBg};
//                     min-height: 100vh;
//                     font-family: 'Outfit', sans-serif;
//                     padding-top: 80px;
//                     padding-bottom: 100px;
//                 }

//                 .fw-800 { font-weight: 800; }

//                 /* Hero Card */
//                 .support-hero-card {
//                     background: ${COLORS.primaryGrad};
//                     border-radius: 24px;
//                     padding: 40px 30px;
//                     position: relative;
//                     overflow: hidden;
//                     color: white;
//                     margin-bottom: 25px;
//                     border-bottom: 5px solid #B5894D;
//                     box-shadow: 0 15px 30px rgba(0,0,0,0.15);
//                 }

//                 .hero-overlay {
//                     position: absolute;
//                     top: 0; right: 0; bottom: 0; left: 0;
//                     background: url('https://www.transparenttextures.com/patterns/carbon-fibre.png');
//                     opacity: 0.1;
//                 }

//                 .hero-content { position: relative; z-index: 1; text-align: center; }
                
//                 .icon-badge {
//                     width: 60px; height: 60px;
//                     background: ${COLORS.accentGrad};
//                     border-radius: 18px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     margin: 0 auto 15px;
//                     box-shadow: 0 8px 20px rgba(181, 137, 77, 0.4);
//                 }

//                 .status-pill {
//                     display: inline-flex;
//                     align-items: center;
//                     gap: 8px;
//                     background: rgba(255,255,255,0.1);
//                     padding: 6px 15px;
//                     border-radius: 100px;
//                     font-size: 12px;
//                     font-weight: 600;
//                     margin-top: 10px;
//                 }

//                 .pulse-dot {
//                     width: 8px; height: 8px;
//                     background: #25D366;
//                     border-radius: 50%;
//                     animation: pulse 1.5s infinite;
//                 }

//                 @keyframes pulse {
//                     0% { transform: scale(1); opacity: 1; }
//                     50% { transform: scale(1.5); opacity: 0.5; }
//                     100% { transform: scale(1); opacity: 1; }
//                 }

//                 /* Mini Info Cards */
//                 .mini-info-card {
//                     background: white;
//                     border-radius: 15px;
//                     padding: 15px 10px;
//                     display: flex;
//                     flex-direction: column;
//                     align-items: center;
//                     text-align: center;
//                     box-shadow: 0 4px 12px rgba(0,0,0,0.03);
//                     border: 1px solid rgba(0,0,0,0.05);
//                 }

//                 .mini-info-card span {
//                     font-size: 11px;
//                     font-weight: 700;
//                     color: ${COLORS.textDark};
//                 }

//                 .section-title {
//                     font-weight: 800;
//                     color: ${COLORS.textDark};
//                     margin: 10px 0 20px 5px;
//                 }

//                 /* Channel Cards */
//                 .channel-card {
//                     background: white;
//                     border-radius: 20px;
//                     padding: 20px;
//                     display: flex;
//                     align-items: center;
//                     text-decoration: none;
//                     gap: 15px;
//                     transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
//                     border: 1px solid #E2E8F0;
//                     box-shadow: 0 8px 20px rgba(0,0,0,0.04);
//                 }

//                 .channel-card:hover {
//                     transform: translateY(-5px);
//                     box-shadow: 0 12px 25px rgba(0,0,0,0.08);
//                 }

//                 .wa-border:hover { border-color: #25D366; }
//                 .tg-border:hover { border-color: #0088CC; }

//                 .channel-icon {
//                     width: 64px; height: 64px;
//                     border-radius: 15px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     color: white;
//                     flex-shrink: 0;
//                 }

//                 .wa-bg { background: ${COLORS.whatsappGrad}; }
//                 .tg-bg { background: ${COLORS.telegramGrad}; }

//                 .channel-text h4 {
//                     margin: 0; font-size: 16px; font-weight: 800; color: ${COLORS.textDark};
//                 }

//                 .channel-text p {
//                     margin: 0; font-size: 13px; color: ${COLORS.textMuted};
//                 }

//                 .arrow-btn {
//                     margin-left: auto;
//                     font-size: 20px;
//                     color: #CBD5E0;
//                     transition: transform 0.3s;
//                 }
//                 .channel-card:hover .arrow-btn { color: ${COLORS.textDark}; transform: translateX(5px); }

//                 /* Helpline Banner */
//                 .helpline-banner {
//                     background: white;
//                     border-radius: 20px;
//                     padding: 15px 20px;
//                     display: flex;
//                     align-items: center;
//                     justify-content: space-between;
//                     border-left: 6px solid ${COLORS.textDark};
//                     box-shadow: 0 10px 25px rgba(0,0,0,0.05);
//                 }

//                 .helpline-left { display: flex; align-items: center; gap: 15px; }

//                 .headset-icon {
//                     background: #F1F5F9;
//                     padding: 12px;
//                     border-radius: 12px;
//                     color: ${COLORS.textDark};
//                 }

//                 .helpline-left h6 { margin: 0; font-weight: 800; color: ${COLORS.textDark}; }
//                 .helpline-left p { margin: 0; font-size: 12px; color: ${COLORS.textMuted}; }

//                 .active-badge {
//                     background: #DCFCE7;
//                     color: #166534;
//                     font-size: 10px;
//                     font-weight: 800;
//                     padding: 5px 12px;
//                     border-radius: 100px;
//                 }

//                 @media (max-width: 768px) {
//                     .support-hero-card { padding: 30px 20px; }
//                     .mini-info-card span { font-size: 10px; }
//                 }
//             `}</style>
//         </>
//     );
// };

// export default Support;


import React, { useEffect, useState } from "react";
import Rightcontainer from "../Components/Rightcontainer";
import socket from "../Components/socket";

import {
  BsWhatsapp,
  BsTelegram,
  BsClockHistory,
} from "react-icons/bs";

import {
  FaHeadset,
  FaShieldAlt,
  FaArrowRight,
} from "react-icons/fa";

import {
  RiMessage2Line,
  RiCustomerService2Line,
  RiCheckboxCircleFill,
} from "react-icons/ri";

// import "./Support.css";


const Support = () => {

  const [settingData, setSettingData] = useState();

  const telegramLink = "https://t.me/";


  // ==========================================
  // GET WEBSITE SETTINGS
  // FUNCTIONALITY SAME
  // ==========================================

  useEffect(() => {

    const storedSetting =
      JSON.parse(localStorage.getItem("sitSetting"));

    if (storedSetting) {
      setSettingData(storedSetting);
    }

    socket.emit("websetting", "");

  }, []);


  useEffect(() => {

    socket.on("websettingGet", (data) => {

      localStorage.setItem(
        "sitSetting",
        JSON.stringify(data)
      );

      setSettingData(data);

    });

    return () =>
      socket.off("websettingGet");

  }, []);


  const whatsappLink =
    settingData?.whatsappSupport;


  return (
    <>

      {/* ========================================
          MAIN SUPPORT PAGE
      ======================================== */}

      <div className="support-page">


        {/* ======================================
            3D BACKGROUND
        ====================================== */}

        <div className="support-orb support-orb-one"></div>

        <div className="support-orb support-orb-two"></div>

        <div className="support-orb support-orb-three"></div>

        <div className="support-grid-bg"></div>


        {/* ======================================
            MAIN LAYOUT
        ====================================== */}

        <div className="support-layout">


          {/* ====================================
              LEFT CONTENT
          ==================================== */}

          <main className="support-main">


            {/* ==================================
                TOP INTRO
            ================================== */}

            <div className="support-heading">

              <div className="support-heading-icon">

                <RiCustomerService2Line />

              </div>

              <div>

                <span className="support-small-title">
                  CUSTOMER CARE
                </span>

                <h1>
                  Help & Support
                </h1>

                <p>
                  We're here to help you whenever you
                  need us.
                </p>

              </div>

            </div>


            {/* ==================================
                HERO CARD
            ================================== */}

            <section className="support-hero">


              {/* animated border */}

              <div className="support-hero-border"></div>


              {/* decorative shapes */}

              <div className="support-hero-circle circle-one"></div>

              <div className="support-hero-circle circle-two"></div>


              <div className="support-hero-content">


                <div className="support-hero-icon">

                  <RiCustomerService2Line />

                  <span></span>

                </div>


                <div className="support-hero-text">

                  <div className="support-live-badge">

                    <span></span>

                    AVAILABLE 24/7

                  </div>


                  <h2>
                    Need Help?
                  </h2>


                  <p>
                    Our support team is ready to assist
                    you with account, payment and
                    gaming related queries.
                  </p>


                  <div className="support-status">

                    <RiCheckboxCircleFill />

                    <span>
                      Support system operational
                    </span>

                  </div>

                </div>


                <div className="support-hero-decoration">
                  ?
                </div>

              </div>

            </section>


            {/* ==================================
                QUICK INFO
            ================================== */}

            <div className="support-info-grid">


              {/* RESPONSE */}

              <div className="support-info-card">

                <div className="info-icon response-icon">

                  <BsClockHistory />

                </div>

                <div>

                  <span>
                    RESPONSE
                  </span>

                  <strong>
                    &lt; 5 Min
                  </strong>

                  <small>
                    Fast assistance
                  </small>

                </div>

              </div>


              {/* SECURITY */}

              <div className="support-info-card">

                <div className="info-icon secure-icon">

                  <FaShieldAlt />

                </div>

                <div>

                  <span>
                    SECURITY
                  </span>

                  <strong>
                    100% Secure
                  </strong>

                  <small>
                    Trusted support
                  </small>

                </div>

              </div>


              {/* LIVE CHAT */}

              <div className="support-info-card">

                <div className="info-icon chat-icon">

                  <RiMessage2Line />

                </div>

                <div>

                  <span>
                    SUPPORT
                  </span>

                  <strong>
                    Live Help
                  </strong>

                  <small>
                    Team online
                  </small>

                </div>

              </div>

            </div>


            {/* ==================================
                CHANNEL HEADER
            ================================== */}

            <div className="support-section-header">

              <div>

                <span>
                  CONTACT US
                </span>

                <h2>
                  Choose a Support Channel
                </h2>

              </div>

              <div className="support-header-line"></div>

            </div>


            {/* ==================================
                SUPPORT CHANNELS
            ================================== */}

            <div className="support-channel-grid">


              {/* =================================
                  WHATSAPP
              ================================= */}

              {whatsappLink && (

                <a
                  href={`https://wa.me/${whatsappLink}`}
                  target="_blank"
                  rel="noreferrer"
                  className="support-channel whatsapp-card"
                >

                  <div className="channel-top-row">

                    <div className="channel-icon whatsapp-icon">

                      <BsWhatsapp />

                    </div>

                    <div className="channel-online">

                      <span></span>

                      ONLINE

                    </div>

                  </div>


                  <div className="channel-content">

                    <span className="channel-label">
                      DIRECT CHAT
                    </span>

                    <h3>
                      WhatsApp Support
                    </h3>

                    <p>
                      Chat directly with our support
                      team for quick assistance.
                    </p>

                  </div>


                  <div className="channel-bottom">

                    <span>
                      Start Conversation
                    </span>

                    <div className="channel-arrow">

                      <FaArrowRight />

                    </div>

                  </div>

                </a>

              )}


              {/* =================================
                  TELEGRAM
              ================================= */}

              <a
                href={telegramLink}
                target="_blank"
                rel="noreferrer"
                className="support-channel telegram-card"
              >

                <div className="channel-top-row">

                  <div className="channel-icon telegram-icon">

                    <BsTelegram />

                  </div>

                  <div className="channel-online telegram-online">

                    <span></span>

                    ACTIVE

                  </div>

                </div>


                <div className="channel-content">

                  <span className="channel-label">
                    COMMUNITY
                  </span>

                  <h3>
                    Telegram Channel
                  </h3>

                  <p>
                    Join our channel for latest news,
                    updates and announcements.
                  </p>

                </div>


                <div className="channel-bottom">

                  <span>
                    Join Channel
                  </span>

                  <div className="channel-arrow">

                    <FaArrowRight />

                  </div>

                </div>

              </a>


            </div>


            {/* ==================================
                HELPLINE CARD
            ================================== */}

            <div className="support-helpline">


              <div className="helpline-icon">

                <FaHeadset />

              </div>


              <div className="helpline-content">

                <span>
                  OFFICIAL HELPLINE
                </span>

                <strong>
                  We're always ready to help
                </strong>

                <p>
                  Trusted support for KAKAKING players
                </p>

              </div>


              <div className="helpline-status">

                <span></span>

                ONLINE NOW

              </div>


            </div>


            {/* ==================================
                SECURITY NOTE
            ================================== */}

            <div className="support-security-note">

              <div className="security-check">

                <FaShieldAlt />

              </div>

              <div>

                <strong>
                  Secure & Official Support
                </strong>

                <p>
                  Never share your password, OTP or
                  sensitive account details with anyone.
                </p>

              </div>

            </div>


          </main>


          {/* ====================================
              RIGHT SIDEBAR
          ==================================== */}

          <aside className="support-right">

            <div className="support-right-sticky">

              <Rightcontainer />

            </div>

          </aside>


        </div>

      </div>

    </>
  );
};


export default Support;